import React from "react";
import { useTranslation } from "react-i18next";
import { useBillingStore } from "../../../stores/billingStore";
import { Icon } from "../UIElements/Icon";

/**
 * Full-page upgrade prompt shown when a subscription feature is not available.
 * CTA opens the existing PlanUpgradeModal via billingStore.
 */
const SubscriptionUpgradePage = ({
  featureName,
  title,
  description,
  icon = "Lock",
}) => {
  const { t } = useTranslation("billing");
  const setShowUpgradeModal = useBillingStore(
    (state) => state.setShowUpgradeModal,
  );

  const displayTitle =
    title || t("featureGate.title", { feature: featureName });
  const displayDescription =
    description || t("featureGate.description", { feature: featureName });

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <div className="w-full max-w-lg text-center">
        {/* Icon */}
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-purple-500/20 to-blue-500/20 ring-1 ring-purple-500/30">
          <Icon name={icon} className="h-10 w-10 text-purple-400" />
        </div>

        {/* Title */}
        <h2 className="mb-3 text-2xl font-bold text-white">{displayTitle}</h2>

        {/* Description */}
        <p className="mx-auto mb-8 max-w-md text-gray-400">
          {displayDescription}
        </p>

        {/* CTA */}
        <button
          type="button"
          onClick={() => setShowUpgradeModal(true)}
          className="inline-flex items-center gap-2 rounded-lg bg-purple-600 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-purple-600/25 transition-all hover:bg-purple-500 hover:shadow-purple-500/30"
        >
          <Icon name="Zap" className="h-4 w-4" />
          {t("featureGate.upgradeButton")}
        </button>
      </div>
    </div>
  );
};

export default SubscriptionUpgradePage;
